import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Reducer,
  Store,
} from 'redux'
import createSagaMiddleware from 'redux-saga'

import {
  reducer as apiReducer,
  saga as apiSaga,
  sessionReducer,
  sessionSaga,
} from '@signavio/effektif-api'
import { saga as reportingSaga } from '@signavio/effektif-reporting'
import { reducer as organizationsReducer } from '@signavio/workflow-organizations'

import mainSaga from '../sagas'

export interface ExtendedStore extends Store {
  asyncReducers?: { [key: string]: Reducer }
  injectReducer?: (key: string, asyncReducer: Reducer) => void
}

const staticReducers = {
  kraken: apiReducer,
  session: sessionReducer,
  organization: organizationsReducer,
}

export default function configureStore() {
  const sagaMiddleware = createSagaMiddleware()

  const composeEnhancers =
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })) ||
    compose

  const finalCreateStore = (composeEnhancers as typeof compose)(
    applyMiddleware(sagaMiddleware)
  )(createStore)

  const store: ExtendedStore = finalCreateStore(createReducer(), {})
  sagaMiddleware.run(apiSaga, store.getState)
  sagaMiddleware.run(sessionSaga)
  sagaMiddleware.run(reportingSaga, store.getState)
  sagaMiddleware.run(mainSaga)

  store.asyncReducers = {}

  store.injectReducer = (key, asyncReducer) => {
    if (!store.asyncReducers?.[key]) {
      store.asyncReducers = { ...store.asyncReducers, [key]: asyncReducer }
      store.replaceReducer(createReducer(store.asyncReducers))
    }
  }

  // make store available in Cypress tests
  if (window.Cypress) {
    window.store = store
  }

  return store
}

function createReducer(asyncReducers?: { [key: string]: Reducer }) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  })
}
